import { z } from "zod";

/** Success response envelope */
export const successResponseSchema = z.object({
  success: z.literal(true),
  data: z.unknown(),
});

/** Error detail in API response */
export const errorDetailSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
  request_id: z.string().optional(),
});

/** Error response envelope */
export const errorResponseSchema = z.object({
  success: z.literal(false),
  error: errorDetailSchema,
});

/** API error codes */
export const ApiErrorCode = {
  AUTH_REQUIRED: "auth.required",
  INVALID_OTP: "auth.otp.invalid",
  OTP_EXPIRED: "auth.otp.expired",
  TOKEN_EXPIRED: "auth.token.expired",
  FORBIDDEN: "auth.forbidden",
  SHOP_FORBIDDEN: "shop.forbidden",
  SHOP_INACTIVE: "shop.inactive",
  SHOP_NOT_FOUND: "shop.not_found",
  SHOP_SCOPE_EMPTY: "shop.scope_empty",
  SHOP_SCOPE_CROSS_WORKSPACE: "shop.scope_cross_workspace",
  NOT_FOUND: "not_found",
  CAMPAIGN_NOT_FOUND: "campaign.not_found",
  CAMPAIGN_AI_UNSUPPORTED_TYPE: "campaign.ai.unsupported_type",
  CAMPAIGN_AI_ACTION_POLICY_REQUIRED: "campaign.ai.action_policy_required",
  SETTINGS_SCHEMA_MISSING: "settings.schema_missing",
  VALIDATION: "validation.error",
  CONFLICT: "resource.state.conflict",
  RATE_LIMITED: "rate_limited",
  AMAZON_API_ERROR: "amazon.api_error",
  AMAZON_REGION_UNSUPPORTED: "amazon.region.unsupported",
  LLM_ERROR: "llm.error",
  AI_MASTER_SWITCH_OFF: "ai.master_switch.off",
  AI_POLICY_INVALID: "ai.policy.invalid",
  AI_RUN_GATES_CLOSED: "ai.run.gates_closed",
  GUARDRAIL_VIOLATION: "ai.guardrail_violation",
  INTERNAL: "internal.error",
} as const;

export type ApiErrorCodeType = (typeof ApiErrorCode)[keyof typeof ApiErrorCode];
